import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../app/TopAppBar';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Typography,Button,Select,MenuItem,IconButton} from '@mui/material';
import SgLogo from '../../Asset/Icons/SgLogo.png';
import axios from 'axios';
import configParam from '../../config';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '../../Asset/Icons/ic_edit.svg';
import { useNavigate } from 'react-router-dom';
import FilterIcon from '../../Asset/Icons/filter_icon.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; 
import GetAppIcon from '@mui/icons-material/GetApp';
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from 'xlsx';



const Reports = () => {
  const ApiURL = configParam.API_URL;
  const access_token = JSON.parse(localStorage.getItem("accesstoken"));
  const [data, setData] = useState([]);
  const [zonesWithoutAssessments, setZonesWithoutAssessments] = useState([]);
  const [monthsAndYears, setMonthsAndYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [sortDirection, setSortDirection] = useState({}); 
  const [notAuditedSortDirection, setNotAuditedSortDirection] = useState({});
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (rowKey) => {
  setExpandedRows((prev) => ({
    ...prev,
    [rowKey]: !prev[rowKey],
  }));
};

const clampStyle = {
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  WebkitLineClamp: 4,
};

const stickyLeft = {
  position: "sticky",
  left: 0,
  zIndex: 3,
  background: "#fff"
};

const stickyRight = {
  position: "sticky",
  right: 0,
  zIndex: 3,
  background: "#fff"
};

  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1; // Months are 0-based
    const currentYear = new Date().getFullYear();
    setSelectedMonth(currentMonth);
    setSelectedYear(currentYear);
  }, []);

  useEffect(() => {
  if (selectedMonth && selectedYear) {
    fetchReportData();
    fetchZonesWithoutAssessments();
  }
}, [selectedMonth, selectedYear]);

useEffect(() => {
  fetchMonthsAndYears(); // This can stay on initial load
}, []);


  // useEffect(() => {
  //   fetchReportData();
  //   fetchZonesWithoutAssessments();
  //   fetchMonthsAndYears();
  // }, [selectedMonth, selectedYear]);

  const fetchMonthsAndYears = async () => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_available_months_and_years`, { headers: { Authorization: `Bearer ${access_token}`}, params: { selectedPlantId } });
      setMonthsAndYears(response.data);
    } catch (error) {
      console.error('Error fetching months and years:', error);
    }
  };


  const fetchReportData = async () => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_avgscore_perzone`, { 
        headers: { Authorization: `Bearer ${access_token}` },
        params: { month: selectedMonth, year: selectedYear,selectedPlantId}
      });
      setData(response.data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };
 


  const fetchZonesWithoutAssessments = async () => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_zones_noassessments`, { 
        headers: { Authorization: `Bearer ${access_token}` },
        params: { month: selectedMonth, year: selectedYear,selectedPlantId}
      });
      setZonesWithoutAssessments(response.data);
    } catch (error) {
      console.error('Error fetching zones without assessments:', error);
    }
  };


  const getAuditLevel = (score) => {
    if (score >= 1 && score <= 6) return 1;
    if (score >= 7 && score <= 12) return 2;
    if (score >= 13 && score <= 18) return 2.5;
    if (score >= 19 && score <= 24) return 3;
    if (score >= 25 && score <= 30) return 3.5;
    if (score >= 31 && score <= 36) return 4;
    return 'Unknown';
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }
  
  
 
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
 


  const handleDownloadRow = async (zoneId, auditDate) => {
  try {
    const response = await axios.get(`${ApiURL}/download-excel-reports`, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: { zoneId, auditDate },
      responseType: 'blob', // Add this line
    });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `Zone_${zoneId}_Audit_${auditDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading excel file:', error);
  }
};


  

// new code (IOS)
const printPdfTable = async () => {
  try {
    // Get the HTML content of the table
    const tableElement = document.getElementById('notAuditedZoneTable');
    const htmlContent = `
      <html>
      <head>
        <title>Zones not Audited Report</title>
        <style>
          /* Add any custom styling for the print version here */
           .table-wrapper {
            overflow-x: auto; /* Enable horizontal scrolling */
            display: block; /* Make the wrapper block to allow scrolling */
            white-space: nowrap; /* Prevent text wrapping */
          }
          table {
            border-collapse: collapse;
            width: 100%;
          
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            
          }
          th {
            background-color: #f2f2f2;
          }
          tr {
            break-inside: avoid; /* Prevent table rows from being split across pages */
          }
          img {
            max-width: 100%;
            height: auto;
            page-break-inside: avoid;
          }
          .logo {
            display: block;
            margin: 0 auto;
          }
        </style>
      </head>
      <body>
        <div>
          <img class="logo" src="${SgLogo}" alt="Company Logo" />
        </div>
        <h2>Zones not Audited</h2>
        ${tableElement.outerHTML}
      </body>
      </html>
    `;

    // Check if the user is on iOS
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

    if (isIOS) {
      // For iOS, download the PDF directly
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.html(htmlContent, {
        callback: function (pdf) {
          pdf.save('zones_not_audited_report.pdf');
        }
      });
    } else {
      // For Android or desktop, open the content in a new window for preview and print
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        throw new Error("Unable to open print window. Please check your browser settings.");
      }

      // Open print window with HTML content and print automatically after loading
      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Wait for the window to load, then trigger print
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  } catch (error) {
    console.error('Error printing PDF:', error);
  }
};

//new code (IOS)
const printPdf = async () => {
  try {
    // Get the HTML content of the table
    const tableElement = document.getElementById('auditedZoneTable');
    
    // Clone the table and remove the last column
    const tableClone = tableElement.cloneNode(true);
    for (let i = 0; i < tableClone.rows.length; i++) {
      tableClone.rows[i].deleteCell(-1); // Remove the last cell of each row
    }

    const htmlContent = `
      <html>
      <head>
        <title>Audited Zone Report</title>
        <style>
        .table-wrapper {
            overflow-x: auto; /* Enable horizontal scrolling */
            display: block; /* Make the wrapper block to allow scrolling */
            white-space: nowrap; /* Prevent text wrapping */
          }
          table {
            border-collapse: collapse;
            width: 100%;
           
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            
          }
          th {
            background-color: #f2f2f2;
          }
          tr {
            break-inside: avoid;
          }
          img {
            max-width: 100%;
            height: auto;
            page-break-inside: avoid;
          }
          .logo {
            display: block;
            margin: 0 auto;
          }
        </style>
      </head>
      <body>
        <div>
          <img class="logo" src="${SgLogo}" alt="Company Logo" />
        </div>
        <h2>Score for the Audited Zone</h2>
        ${tableClone.outerHTML}
      </body>
      </html>
    `;

    // Check if the user is on iOS
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

    if (isIOS) {
      // For iOS, directly download the PDF
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.html(htmlContent, {
        callback: function (pdf) {
          pdf.save('audited_zone_report.pdf');
        }
      });
    } else {
      // For Desktop or Android, open the content in a new window for preview and print
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        throw new Error("Unable to open print window. Please check your browser settings.");
      }

      // Open print window with HTML content and print automatically after loading
      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Wait for the window to load, then trigger print
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  } catch (error) {
    console.error('Error printing PDF:', error);
  }
};


  //new code
  const exportTableToExcel = (tableId, filename) => {
    const table = document.getElementById(tableId);
    if (!table) {
      console.error("Table element not found");
      return;
    }

    const ws = XLSX.utils.table_to_sheet(table);

    // Set column width dynamically based on the longest content
    const colWidths = [];
    const range = XLSX.utils.decode_range(ws['!ref']);

    for (let C = range.s.c; C <= range.e.c; ++C) {
        let maxWidth = 10; // Default min width
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = ws[cellAddress];
            if (cell && cell.v) {
                const cellValue = String(cell.v);
                maxWidth = Math.max(maxWidth, cellValue.length + 2); // Add padding
            }
        }
        colWidths.push({ wch: maxWidth });
    }

    ws['!cols'] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Force download
    XLSX.writeFile(wb, filename);
};

 
  const handleDownloadAuditedZoneExcel = () => {
    exportTableToExcel('auditedZoneTable', 'audited_zone_report.xlsx');
  };

  const handleDownloadNotAuditedZoneExcel = () => {
    exportTableToExcel('notAuditedZoneTable', 'not_audited_zone_report.xlsx');
  };
 
  const filteredData = data.filter((row) => row.totpoints !== "0");
  console.log("filetereddataaaaaaaa",filteredData)
  console.log("dataaaaaaaaa",data)
  const handleSort = (column) => {
    const direction = sortDirection[column] === 'asc' ? 'desc' : 'asc';
    setSortDirection({ [column]: direction });
  
    const sortedData = [...filteredData].sort((a, b) => {
      let aValue, bValue;
  
      // Handle specific columns for numeric sorting
      if (column === 'totlsixpoints') {
        aValue = parseFloat(a[column]) || 0; // Convert to float, default to 0 if NaN
        bValue = parseFloat(b[column]) || 0; // Convert to float, default to 0 if NaN
      } else if (column === 'auditLevel') {
        // Sort by totpoints for audit level
        aValue = parseFloat(a.totpoints) || 0;
        bValue = parseFloat(b.totpoints) || 0;
      } else if (column === 'auditor_name' || column === 'zone_first' || column === 'grp_first') {
        // Sort by first name
        aValue = a[column].split(' ')[0].toLowerCase(); // Get first name and convert to lower case
        bValue = b[column].split(' ')[0].toLowerCase(); // Get first name and convert to lower case
      } else {
        aValue = a[column];
        bValue = b[column];
      }
  
      if (direction === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
  
    setData(sortedData);
  };
  const handleNotAuditedSort = (column) => {
    const direction = notAuditedSortDirection[column] === 'asc' ? 'desc' : 'asc';
    setNotAuditedSortDirection({ [column]: direction });
  
    const sortedData = [...zonesWithoutAssessments].sort((a, b) => {
      let aValue, bValue;
  
      // Handle sorting for auditor, zone leader, and group leader
      if (column === 'auditor') {
        aValue = a.auditor_first_name.toLowerCase();
        bValue = b.auditor_first_name.toLowerCase();
      } else if (column === 'zone_leader') {
        aValue = a.zone_leader_first_name.toLowerCase();
        bValue = b.zone_leader_first_name.toLowerCase();
      } else if (column === 'group_leader') {
        aValue = a.group_leader_first_name.toLowerCase();
        bValue = b.group_leader_first_name.toLowerCase();
      } else {
        aValue = a[column];
        bValue = b[column];
      }
  
      return direction === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue < bValue ? 1 : -1);
    });
  
    setZonesWithoutAssessments(sortedData);
  };

const renderNumbered = (items, sNumber,isExpanded) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
     <div
      style={{
        fontSize: "13px",
        ...(isExpanded ? {} : clampStyle),
      }}
    >
      {items.map((item, index) => (
        <div key={index}>
          <strong>
            {sNumber}.{item.questionNo}
          </strong>{" "}
          {item.remark}
        </div>
      ))}
    </div>
  );
};



// const renderNumbered = (items, sNumber) => {
//   if (!items) return null;

//   // Convert string to array if needed
//   const itemArray = Array.isArray(items)
//     ? items
//     : items.split(",").map((item) => item.trim()).filter(Boolean);

//   if (itemArray.length === 0) return null;

//   return (
//     <div style={{ fontSize: "13px" }}>
//       {itemArray.map((remark, index) => (
//         <div key={index}>
//           <strong>
//             {sNumber}.{index + 1}
//           </strong>{" "}
//           {remark}
//         </div>
//       ))}
//     </div>
//   );
// };

const sColumnWidth = { minWidth: 220 };   // 👈 adjust value as needed

  return (
   
    <div style={{ padding: "16px"}}>
      {/* <Header pageTitle="Reports" /> */}
      <div>
      <div style={{justifyContent:'flex-end',display:'flex',marginBottom:'35px'}}>
     
      <select value={selectedMonth} onChange={handleMonthChange}>
            <option value="">Select Month</option>
                  
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
          <select value={selectedYear} onChange={handleYearChange}>
            <option value="">Select Year</option>
            {[...new Set(monthsAndYears.map(item => item.year))].map((year, index) => (
              <option key={index} value={year}>{year}</option>
            ))}
          </select>

</div>
{/* <Typography variant="h6" gutterBottom>
          Score for the Audited Zone
        </Typography> */}
      <div style={{display:'flex',justifyContent:'space-between'}} >
        <div style={{ marginBottom: '10px',justifyContent: 'flex-start', display: 'flex'  }}>
        <Typography variant="h6" gutterBottom>
          Score for the Audited Zone
        </Typography>
        </div>
        <div style={{ marginBottom: '10px',justifyContent: 'flex-end', display: 'flex'  }}>
        {/* <Button onClick={printPdf} style={{backgroundColor:'#3498DB',color:'white',marginRight:'15px'}}>View PDF</Button>
         */}
         <Button
  onClick={() => printPdf("auditedZoneTable", "Audited Zone Report", "audited_zone_report.pdf")}
  style={{ backgroundColor: "#3498DB", color: "white", marginRight: "15px" }}
>
  View PDF
</Button>

        <Button onClick={handleDownloadAuditedZoneExcel} style={{backgroundColor:'#3498DB',color:'white'}}>Download as Excel</Button>
        </div>
        </div>
    
        {/* {filteredData.length > 0 ? ( */}
        <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
  <Table id="auditedZoneTable" sx={{ minWidth: 2600 }}>
    <TableHead>
      <TableRow>
      <TableCell sx={{ ...sColumnWidth, ...stickyLeft }} onClick={() => handleSort('sno')}>S.No</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('code')}>Zone Code</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('name')}>Zone Name</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('auditLevel')}>Audit Level</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('totpoints')}>Audit Score</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('totlsixpoints')}>6 months Average Score</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('auditor_name')}>Auditor Name</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('zone_first')}>Leader</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('grp_first')}>Group Leader</TableCell>
                <TableCell sx={sColumnWidth} onClick={() => handleSort('audit_date')}>Audit Date</TableCell>
                <TableCell sx={sColumnWidth}>1S (0)</TableCell>
<TableCell sx={sColumnWidth}>1S (1)</TableCell>
<TableCell sx={sColumnWidth}>2S (0)</TableCell>
<TableCell sx={sColumnWidth}>2S (1)</TableCell>
<TableCell sx={sColumnWidth}>3S (0)</TableCell>
<TableCell sx={sColumnWidth}>3S (1)</TableCell>
<TableCell sx={sColumnWidth}>4S (0)</TableCell>
<TableCell sx={sColumnWidth}>4S (1)</TableCell>
<TableCell sx={sColumnWidth}>5S (0)</TableCell>
<TableCell sx={sColumnWidth}>5S (1)</TableCell>
<TableCell sx={sColumnWidth}>6S (0)</TableCell>
<TableCell sx={sColumnWidth}>6S (1)</TableCell>

        {/* <TableCell>S.No</TableCell>
        <TableCell>Zone Code</TableCell>
        <TableCell>Zone Name</TableCell>
        <TableCell>Audit Level</TableCell>
        <TableCell>Audit Score</TableCell>
        <TableCell> 6 months Average Score</TableCell>
        <TableCell>Auditor Name</TableCell>
        <TableCell>Leader</TableCell>
        <TableCell>Group Leader</TableCell>
        <TableCell>Audit Date</TableCell>*/}
        <TableCell sx={stickyRight}>Download</TableCell> 
      </TableRow>
    </TableHead>
    
    {filteredData.length > 0 ? (
     <TableBody>
      {data
    .filter((row) => row.totpoints !== "0")
    .map((row, index) => {
      // const rowKey = row.zoneId + row.month;
      // const isExpanded = expandedRows[rowKey];
const rowKey = `${row.zone_id}-${row.audit_date}`;
      const isExpanded = !!expandedRows[rowKey];
      return (
        <TableRow key={rowKey}>
          <TableCell sx={{ ...sColumnWidth, ...stickyLeft }}>{index + 1}</TableCell>
          <TableCell sx={sColumnWidth}>{row.code}</TableCell>
          <TableCell sx={sColumnWidth}>{row.name}</TableCell>
          <TableCell sx={sColumnWidth}>{getAuditLevel(row.totpoints)}</TableCell>
          <TableCell sx={sColumnWidth}>{row.totpoints}</TableCell>
          <TableCell sx={sColumnWidth}>{row.totlsixpoints}</TableCell>
          <TableCell sx={sColumnWidth}>{row.auditor_name}</TableCell>
          <TableCell sx={sColumnWidth}>
            {row.zone_first} {row.zonelast}
          </TableCell>
          <TableCell sx={sColumnWidth}>
            {row.grp_first} {row.grplast}
          </TableCell>
          <TableCell sx={sColumnWidth}>{formatDate(row.audit_date)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["1S_0"], 1, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["1S_1"], 1, isExpanded)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["2S_0"], 2, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["2S_1"], 2, isExpanded)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["3S_0"], 3, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["3S_1"], 3, isExpanded)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["4S_0"], 4, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["4S_1"], 4, isExpanded)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["5S_0"], 5, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["5S_1"], 5, isExpanded)}</TableCell>

          <TableCell sx={sColumnWidth}>{renderNumbered(row["6S_0"], 6, isExpanded)}</TableCell>
          <TableCell sx={sColumnWidth}>{renderNumbered(row["6S_1"], 6, isExpanded)}</TableCell>

       <TableCell
  sx={{
    minWidth: 140,
    whiteSpace: "nowrap",
    ...stickyRight
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    
    <IconButton
      onClick={() => handleDownloadRow(row.zone_id, row.audit_date)}
      size="small"
    >
      <GetAppIcon />
    </IconButton>

    <IconButton
      onClick={() => toggleRow(rowKey)}
      size="small"
      style={{
        transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
        transition: "0.3s"
      }}
    >
      <ExpandMoreIcon />
    </IconButton>

  </div>
</TableCell>

        </TableRow>
      );
    })}
      {/* {data
        .filter((row) => row.totpoints !== "0")
        .map((row, index) => (
          
          <TableRow key={row.zoneId + row.month}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{row.code}</TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{getAuditLevel(row.totpoints)}</TableCell>
            <TableCell>{row.totpoints}</TableCell>
            <TableCell>{row.totlsixpoints}</TableCell>
            <TableCell>{row.auditor_name}</TableCell>
            <TableCell>{row.zone_first} {row.zonelast}</TableCell>
            <TableCell>{row.grp_first} {row.grplast}</TableCell>
            <TableCell>{formatDate(row.audit_date)}</TableCell>
           <TableCell>{renderNumbered(row["1S_0"], 1)}</TableCell>
<TableCell>{renderNumbered(row["1S_1"], 1)}</TableCell>

<TableCell>{renderNumbered(row["2S_0"], 2)}</TableCell>
<TableCell>{renderNumbered(row["2S_1"], 2)}</TableCell>

<TableCell>{renderNumbered(row["3S_0"], 3)}</TableCell>
<TableCell>{renderNumbered(row["3S_1"], 3)}</TableCell>

<TableCell>{renderNumbered(row["4S_0"], 4)}</TableCell>
<TableCell>{renderNumbered(row["4S_1"], 4)}</TableCell>

<TableCell>{renderNumbered(row["5S_0"], 5)}</TableCell>
<TableCell>{renderNumbered(row["5S_1"], 5)}</TableCell>

<TableCell>{renderNumbered(row["6S_0"], 6)}</TableCell>
<TableCell>{renderNumbered(row["6S_1"], 6)}</TableCell>



            <TableCell>
            <IconButton onClick={() => handleDownloadRow(row.zone_id, row.audit_date)}>
                    <GetAppIcon />
                  </IconButton>
                    </TableCell>
          </TableRow>
        ))} */}
    </TableBody> 
     ) : (
      <Typography
      variant="body1"
      gutterBottom
      style={{ textAlign: 'center', marginTop: '20px' }}
    >
        No data found.
      </Typography>
    )}
  </Table>
</TableContainer>
 

<div style={{display:'flex',justifyContent:'space-between',marginTop:'35px'}} >

<div style={{ marginBottom: '10px',justifyContent: 'flex-start', display: 'flex'  }}>
        <Typography variant="h6" gutterBottom>
         Zones not Audited
        </Typography>
        </div>
        <div style={{ marginBottom: '10px',justifyContent: 'flex-end', display: 'flex'}}>
        {/* <Button onClick={printPdfTable} style={{backgroundColor:'#3498DB',color:'white',marginRight:'15px'}}>View PDF</Button> */}
        <Button
  onClick={() => printPdfTable("notAuditedZoneTable", "Zones Not Audited Report", "not_audited_zone_report.pdf")}
  style={{ backgroundColor: "#3498DB", color: "white", marginRight: "15px" }}
>
  View PDF
</Button>
        <Button onClick={handleDownloadNotAuditedZoneExcel}style={{backgroundColor:'#3498DB',color:'white'}}>Download as Excel</Button>
        </div>
        </div>
        <TableContainer component={Paper}>
          <Table id="notAuditedZoneTable">
            <TableHead>
              <TableRow>
              <TableCell onClick={() => handleNotAuditedSort('sno')}>S.No</TableCell>
                <TableCell onClick={() => handleNotAuditedSort('zone_code')}>Zone Code</TableCell>
                <TableCell onClick={() => handleNotAuditedSort('zone_name')}>Zone Name</TableCell>
                <TableCell onClick={() => handleNotAuditedSort('auditor')}>Auditor</TableCell>
                <TableCell onClick={() => handleNotAuditedSort('zone_leader')}>Leader</TableCell>
                <TableCell onClick={() => handleNotAuditedSort('group_leader')}>Group Leader</TableCell>
                {/* <TableCell>S.No</TableCell>
                <TableCell>Zone Code</TableCell>
                <TableCell>Zone Name</TableCell>
                <TableCell>Auditor</TableCell>
                <TableCell> Leader </TableCell>
                <TableCell>Group Leader</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {zonesWithoutAssessments.map((zone, index) => (
                <TableRow key={zone.zone_id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{zone.zone_code}</TableCell>
                  <TableCell>{zone.zone_name}</TableCell>
                  <TableCell>{zone.auditor_first_name} {zone.auditor_last_name}</TableCell>
                  <TableCell>{zone.zone_leader_first_name} {zone.zone_leader_last_name}</TableCell>
                  <TableCell>{zone.group_leader_first_name} {zone.group_leader_last_name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Reports;



//Old code

// const Reports = () => {
//   const ApiURL = configParam.API_URL;
//   const access_token = JSON.parse(localStorage.getItem("accesstoken"));
//   const secret_key = JSON.parse(localStorage.getItem("secret"));
//   const [data, setData] = useState([]);
//   const [zonesWithoutAssessments, setZonesWithoutAssessments] = useState([]);
//   const [monthsAndYears, setMonthsAndYears] = useState([]);
//   const [selectedMonth, setSelectedMonth] = useState('');
//   const [selectedYear, setSelectedYear] = useState('');
//   useEffect(() => {
//     fetchReportData();
//     fetchZonesWithoutAssessments();
//     fetchMonthsAndYears();
//   }, []);

//   useEffect(() => {
//     if (selectedMonth !== '' || selectedYear !== '') {
//       fetchReportData(); // Fetch report data when either month or year is selected
//     }
//   }, [selectedMonth, selectedYear]);



//   const fetchMonthsAndYears = async () => {
//     try {
//       const response = await axios.get(`${ApiURL}/get_available_months_and_years`, { headers: { Authorization: `Bearer ${access_token}`, secret_key } });
//       setMonthsAndYears(response.data);
//     } catch (error) {
//       console.error('Error fetching months and years:', error);
//     }
//   };


//   const fetchReportData = async () => {
//     try {
//       // const response = await axios.get(`${ApiURL}/get_avgscore_perzone`, { headers: { Authorization: `Bearer ${access_token}`, secret_key } });
//       const response = await axios.get(`${ApiURL}/get_avgscore_perzone`, { 
//         headers: { Authorization: `Bearer ${access_token}`, secret_key },
//         params: { month: selectedMonth, year: selectedYear }
//       });
//       // Filter the data to include only the latest month's data for each zone
//       const latestMonthData = filterLatestMonthData(response.data);
//       setData(latestMonthData);
//     } catch (error) {
//       console.error('Error fetching reports:', error);
//     }
//   };


//   const fetchZonesWithoutAssessments = async () => {
//     try {
//       const response = await axios.get(`${ApiURL}/get_zones_noassessments`, { 
//         headers: { Authorization: `Bearer ${access_token}`, secret_key },
//         params: { month: selectedMonth, year: selectedYear }
//       });
//       setZonesWithoutAssessments(response.data);
//     } catch (error) {
//       console.error('Error fetching zones without assessments:', error);
//     }
//   };
  


//   // Function to filter only the latest month's data for each zone
//   const filterLatestMonthData = (data) => {
//     const latestMonthData = {};
//     data.forEach(row => {
//       if (!latestMonthData[row.zoneId] || new Date(row.month) > new Date(latestMonthData[row.zoneId].month)) {
//         latestMonthData[row.zoneId] = row;
//       }
//     });
//     return Object.values(latestMonthData);
//   };
//   const getAuditLevel = (score) => {
//     if (score >= 1 && score <= 6) return 1;
//     if (score >= 7 && score <= 12) return 2;
//     if (score >= 13 && score <= 18) return 2.5;
//     if (score >= 19 && score <= 24) return 3;
//     if (score >= 25 && score <= 30) return 3.5;
//     if (score >= 31 && score <= 36) return 4;
//     return 'Unknown';
//   };
//   function formatDate(dateString) {
//     const date = new Date(dateString);
//     const day = date.getDate();
//     const month = date.toLocaleString('default', { month: 'short' });
//     const year = date.getFullYear();
//     return `${day} ${month} ${year}`;
//   }
  
//   const handleMonthChange = (event) => {
//     const selectedMonth = event.target.value;
//     setSelectedMonth(selectedMonth);
//     fetchReportData(selectedMonth, selectedYear); // Fetch data immediately after updating month
//   };
  
//   const handleYearChange = (event) => {
//     const selectedYear = event.target.value;
//     setSelectedYear(selectedYear);
//     fetchReportData(selectedMonth, selectedYear); // Fetch data immediately after updating year
//   };


//   const printPdf = async () => {
//     try {
//       // Get the HTML content of the table
//       const tableElement = document.getElementById('auditedZoneTable');
//       const htmlContent = `
//         <html>
//         <head>
//           <title>Audited Zone Report</title>
//           <style>
//             /* Add any custom styling for the print version here */
//             table {
//               border-collapse: collapse;
//               width: 100%;
//             }
//             th, td {
//               border: 1px solid black;
//               padding: 8px;
//               text-align: left;
//             }
//             th {
//               background-color: #f2f2f2;
//             }
//             tr {
//               break-inside: avoid; /* Prevent table rows from being split across pages */
//             }
//           </style>
//         </head>
//         <body>
//           <h2>Score for the Audited Zone</h2>
//           ${tableElement.outerHTML}
//         </body>
//         </html>
//       `;
  
//       // Open a new window and write the HTML content to it
//       const printWindow = window.open('', '_blank');
//       printWindow.document.write(htmlContent);
//       printWindow.document.close();
  
//       // Print the contents of the new window
//       printWindow.print();
//     } catch (error) {
//       console.error('Error printing PDF:', error);
//     }
//   };
  
  
//   const printPdfTable = async () => {
//     try {
//       // Get the HTML content of the table
//       const tableElement = document.getElementById('notAuditedZoneTable');
//       const htmlContent = `
//         <html>
//         <head>
//           <title>Zones not Audited Report</title>
//           <style>
//             /* Add any custom styling for the print version here */
//             table {
//               border-collapse: collapse;
//               width: 100%;
//             }
//             th, td {
//               border: 1px solid black;
//               padding: 8px;
//               text-align: left;
//             }
//             th {
//               background-color: #f2f2f2;
//             }
//             tr {
//               break-inside: avoid; /* Prevent table rows from being split across pages */
//             }
//           </style>
//         </head>
//         <body>
//           <h2>Zones not Audited</h2>
//           ${tableElement.outerHTML}
//         </body>
//         </html>
//       `;
  
//       // Open a new window and write the HTML content to it
//       const printWindow = window.open('', '_blank');
//       printWindow.document.write(htmlContent);
//       printWindow.document.close();
  
//       // Print the contents of the new window
//       printWindow.print();
//     } catch (error) {
//       console.error('Error printing PDF:', error);
//     }
//   };
  


//   const exportTableToExcel = (tableId, filename) => {
//     const table = document.getElementById(tableId);
  
//     // Adjust column width for better display
//     const columnWidths = [25, 25, 25, 25, 25, 25, 25, 25, 25, 25]; // Adjust the widths as needed
//     const wscols = columnWidths.map((width, idx) => ({ wch: width }));
  
//     // Iterate through the table rows and cells to adjust the date format
//     for (let i = 1; i < table.rows.length; i++) {
//       const row = table.rows[i];
//       for (let j = 0; j < row.cells.length; j++) {
//         const cell = row.cells[j];
//         // Check if the cell is in the last column (Audit Date)
//         if (j === row.cells.length - 1) {
//           // Get the text content of the cell (date string)
//           const dateString = cell.textContent.trim();
//           // Format the date string using formatDate function
//           const formattedDate = formatDate(dateString);
//           // Update the cell content with the formatted date
//           cell.textContent = formattedDate;
//         }
//       }
//     }
  
//     // Create worksheet with column headings
//     const ws = XLSX.utils.table_to_sheet(table, { sheet: "Sheet 1", raw: true });
//     ws['!cols'] = wscols;
//     ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: table.rows.length, c: table.rows[0].cells.length } }) };
  
//     // Ensure that the header row is preserved
//     const headerRow = table.rows[0];
//     for (let j = 0; j < headerRow.cells.length; j++) {
//       ws[XLSX.utils.encode_cell({ r: 0, c: j })].v = headerRow.cells[j].textContent;
//     }
  
//     // Convert the worksheet to workbook
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
  
//     // Convert the workbook to binary data
//     const binaryData = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  
//     // Create a Blob object containing the binary data
//     const blob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
//     // Trigger download by creating a link element
//     saveAs(blob, filename);
//   };
  
  
  
//   const handleDownloadAuditedZoneExcel = () => {
//     exportTableToExcel('auditedZoneTable', 'audited_zone_report.xlsx');
//   };

//   const handleDownloadNotAuditedZoneExcel = () => {
//     exportTableToExcel('notAuditedZoneTable', 'not_audited_zone_report.xlsx');
//   };
 
//   return (
//     <div>
//       <Header pageTitle="Reports" />
//       <div style={{marginTop:'55px'}}>
//       <div style={{justifyContent:'flex-end',display:'flex'}}>
     



//   <select value={selectedMonth} onChange={handleMonthChange}>
//     <option value="">Select Month</option>
//     {monthsAndYears.map((item, index) => (
//       <option key={index} value={item.month}>{new Date(0, item.month - 1).toLocaleString('en', { month: 'long' })}</option>
//     ))}
//   </select>
//   <select value={selectedYear} onChange={handleYearChange}>
//     <option value="">Select Year</option>
//     {[...new Set(monthsAndYears.map(item => item.year))].map((year, index) => (
//       <option key={index} value={year}>{year}</option>
//     ))}
//   </select>
// </div>

//       <Typography variant="h6" gutterBottom>
//           Score for the Audited Zone
//         </Typography>
//         <div style={{ marginBottom: '10px' }}>
//         <Button onClick={printPdf}>View PDF</Button>
//         <Button onClick={handleDownloadAuditedZoneExcel}>Download as Excel</Button>
//         </div>
//         <TableContainer component={Paper}>
//           <Table id="auditedZoneTable">
//             <TableHead>
//               <TableRow>
//                 <TableCell>S.No</TableCell>
//                 <TableCell>Zone Code</TableCell>
//                 <TableCell>Zone Name</TableCell>
//                 <TableCell>Audit Level</TableCell>
//                 <TableCell>Audit Score</TableCell>
//                 <TableCell>Average Score</TableCell>
//                 <TableCell>Auditor Name</TableCell>
//                 <TableCell> Leader </TableCell>
//                 <TableCell>Group Leader </TableCell>
//                 <TableCell>Audit Date</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {data.map((row, index) => (
//                 <TableRow key={row.zoneId + row.month}>
//                   <TableCell>{index + 1}</TableCell>
//                   <TableCell>{row.zoneCode}</TableCell>
//                   <TableCell>{row.zoneName}</TableCell>
//                   <TableCell>{getAuditLevel(row.totalScore)}</TableCell>
//                   <TableCell>{row.totalScore}</TableCell>
//                   <TableCell>{row.averageScore}</TableCell>
//                   <TableCell>{row.auditorName}</TableCell>
//                   <TableCell>{row.zoneLeaderName !== "null null" ? row.zoneLeaderName : ''}</TableCell>
//                   <TableCell>{row.groupLeaderName !== "null null" ? row.groupLeaderName : ''}</TableCell>
                 
                 
//                   <TableCell>{formatDate(row.auditDate)}</TableCell>
                  
//                   {/* <TableCell>{formatDate(row.month)}</TableCell>  */}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>


//         <Typography variant="h6" gutterBottom style={{ marginTop: '55px' }}>
//           Zones not Audited
//         </Typography>
//         <div style={{ marginBottom: '10px' }}>
//         <Button onClick={printPdfTable}>View PDF</Button>
//         <Button onClick={handleDownloadNotAuditedZoneExcel}>Download as Excel</Button>
//         </div>
//         <TableContainer component={Paper}>
//           <Table id="notAuditedZoneTable">
//             <TableHead>
//               <TableRow>
//                 <TableCell>S.No</TableCell>
//                 <TableCell>Zone Code</TableCell>
//                 <TableCell>Zone Name</TableCell>
//                 <TableCell> Leader </TableCell>
//                 <TableCell>Group Leader</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {zonesWithoutAssessments.map((zone, index) => (
//                 <TableRow key={zone.zone_id}>
//                   <TableCell>{index + 1}</TableCell>
//                   <TableCell>{zone.zone_code}</TableCell>
//                   <TableCell>{zone.zone_name}</TableCell>
//                   <TableCell>{zone.zone_leader_first_name} {zone.zone_leader_last_name}</TableCell>
//                   <TableCell>{zone.group_leader_first_name} {zone.group_leader_last_name}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </div>
//     </div>
//   );
// };

// export default Reports;




 

 

